export default {
  ESCAPE_URL: 'http://www.americanexpress.ch/',
} as const
